/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_appsync_graphqlEndpoint": "https://c2e5dt7n6rajpi535hpvkdr2oi.appsync-api.eu-west-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-lwueiffrzveixd4ybrbbkcotoq",
    "aws_cognito_identity_pool_id": "eu-west-1:ad47ee46-df0b-4393-835b-e50d077133c6",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_DTQuSWqIL",
    "aws_user_pools_web_client_id": "6cj661prspouo793d4i1hjne9q",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_UPPERCASE"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "workdistrict-video102642-staging",
    "aws_user_files_s3_bucket_region": "eu-west-1"
};


export default awsmobile;
